import { KikCommonUtils } from "@kikocosmeticsorg/uc-api-nest-common-fe";

export class CommonUtils extends KikCommonUtils {
  static sanitizeLocale(locale: string | undefined) {
    return locale?.replace(/-\w\w/, (m) => {
      return m.toUpperCase();
    });
  }
}

export default CommonUtils;
